module.exports = __webpack_public_path__ + "static/img/SearchCountry.2f477128.png";